import React from 'react';
import { ITranslator } from '@wix/ai-scheduling-assistant-localization';
import { loadMessages, loadUouChatMessages } from '@wix/ai-scheduling-assistant-localization/web';
import { i18n, initI18n, Trans } from '@wix/wix-i18n-config';

export class UouChatTranslator implements ITranslator<JSX.Element> {
  private i18n: i18n | undefined;

  private checkInitialized() {
    if (!this.i18n) {
      throw new Error('Translator not initialized');
    }

    return this.i18n;
  }

  getI18n() {
    return this.checkInitialized();
  }

  translate(key: string, params: Record<string, string>): string {
    return this.checkInitialized().t(key, params);
  }

  translateWithChildren(key: string, params: Record<string, string>, children: JSX.Element): JSX.Element {
    this.checkInitialized();

    return (
      <Trans tOptions={params} i18nKey={key}>
        {children}
      </Trans>
    );
  }

  async initialize(locale: string) {
    const keys = await Promise.all([loadUouChatMessages(locale), loadMessages(locale)]);
    this.i18n = initI18n({
      locale,
      messages: keys.reduce((acc, val) => ({ ...acc, ...val }), {}),
    });
  }
}
